import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'numberToPrecision',
    standalone: false
})

export class NumberToPrecisionPipe implements PipeTransform {
    transform(value: any): any {

        if(value == null || value == undefined) {
            return "-";
        }

        if (!isNaN(+value)) {
            return (+value).toPrecision(4).toLocaleString();
        } else {
            return value;
        }
    }
}